var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_4385_4758)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.53656 11.1225L10.5294 6.8775M10.5294 11.1225L6.53656 6.8775M6.41663 16.5H10.6493C14.1765 16.5 15.5874 15 15.5874 11.25V6.75C15.5874 3 14.1765 1.5 10.6493 1.5H6.41663C2.88941 1.5 1.47852 3 1.47852 6.75V11.25C1.47852 15 2.88941 16.5 6.41663 16.5Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4385_4758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.9307,
    height: 18,
    fill: "white",
    transform: "translate(0.0683594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d816ea9fecc50050f7cc37aef6e23328.svg";
export { ForwardRef as ReactComponent };